import { motion } from "framer-motion";
import { serviceReveal, ServiceIllustration, ServiceDescription, ServiceActions } from "./services/ServiceParts";

export const ServiceSection = ({ service, reverse, onQuote, onAi }) => (
  <section id={service.id} className="relative py-20 sm:py-28 overflow-hidden" data-testid={`service-section-${service.id}`}>
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: `radial-gradient(620px circle at ${reverse ? "72%" : "28%"} 50%, ${service.glow}, transparent 70%)` }} />
    <div className="max-w-6xl mx-auto px-5 sm:px-8 relative grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
      <ServiceIllustration service={service} reverse={reverse} />
      <motion.div {...serviceReveal} className={reverse ? "lg:order-1" : ""}>
        <ServiceDescription service={service} />
        <ServiceActions service={service} onQuote={onQuote} onAi={onAi} />
      </motion.div>
    </div>
  </section>
);